export default __webpack_public_path__ + "static/media/alphabet-yellow-r.01b0b55c.png";